import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Topic extends React.Component {
  constructor(props) {
    super(props)

    this.config = {
      types : [ 
        {
          title: 'horizontal',
          isDefault: true,
        },
        'vertical',
        'inverse', 
        'icon',
        'number'
      ],
      modifiers : [ 
        {
          title: 'sm',
          isDefault: true,
        },
        'md',
        'lg'
      ],
      states :[]
    }
  }
  
  render() {
    const { 
      horizontal,
      vertical,
      inverse,
      icon,
      iconSrc,
      number,
      sm,
      md,
      lg,
      children, 
      ...rest
    } = this.props
    let fixedIcon = icon || iconSrc
    return <div {...rest} className={resolveProps(this.props, this.config, 'Topic') + (vertical ? ' mdn-Topic--icon' : '')}>
      <div className="mdn-Topic-symbol">
        {fixedIcon ? <span className={`mdn-Icon-${fixedIcon} mdn-Icon--md`} /> : null}
        {(number && !fixedIcon) ? number  : null}
      </div>
      <p className="mdn-Topic-description">
        {children}
      </p>
    </div>
    
  }
}

Topic.propTypes = {
  children : PropTypes.node,
  iconSrc : PropTypes.string,
  text : PropTypes.string,
  vertical : PropTypes.bool
}